// extracted by mini-css-extract-plugin
export var borderRadius = "_65-4";
export var large = "_65-3";
export var logoContainer = "_65-0";
export var nameLogo = "_65-2";
export var small = "_65-1";